import { fmtEuro } from '@/lib/utils';
import { cn } from '@/lib/utils';

export type TierMarkerProps = {
  tier: 1 | 2 | 3;
  label: string; // ex "3 mois"
  target: number;
  current: number;
};

export function TierMarker({ tier, label, target, current }: TierMarkerProps) {
  const reached = current >= target;
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border px-3 py-2 text-center transition-colors',
        reached
          ? 'bg-success/10 border-success/30 text-success'
          : 'bg-muted/50 border-border text-muted-foreground'
      )}
    >
      <span className="text-[10px] font-bold uppercase tracking-wider">P{tier}</span>
      <strong className="text-sm font-bold num">{fmtEuro(target)}</strong>
      <em className="text-[10px] not-italic text-muted-foreground">{label}</em>
    </div>
  );
}
